import type { WebFrameProps } from "common/components/WebFrame";
import { MediaContainer, WebFrame } from "common/components/WebFrame";

type MediaPlayerProps = WebFrameProps & { isVideo?: boolean };

export const MediaPlayer = ({ isVideo, ...props }: MediaPlayerProps) => {
  if (isVideo) {
    return (
      <MediaContainer className={props.className}>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video src={props.url} controls />
      </MediaContainer>
    );
  }
  return <WebFrame {...props} />;
};
